let GQL_SERVER_ADDRESS = null;
let AUTH_URL = null;
const API_URL = process.env.REACT_APP_API_URL;
const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || 'https';
if (API_URL) {
	GQL_SERVER_ADDRESS = API_PROTOCOL + "://" + API_URL + "/graphql/";
	AUTH_URL = API_PROTOCOL + "://" + API_URL + "/api-token-auth/";
} else {
	GQL_SERVER_ADDRESS = 'http://127.0.0.1:8000/graphql/';
	AUTH_URL = 'http://127.0.0.1:8000/api-token-auth/';
}
export { GQL_SERVER_ADDRESS, AUTH_URL};


// WEBPACK FOOTER //
// ./src/config/conf.js